/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import logger from '../utils/logger';
import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Modal from './Modal';
import { versionlist } from '../api/api';
import { useLangMap } from '../hooks/useLangMap';
import { useTranslation } from '../hooks/useTranslation';
import CustomAlert from './CustomAlert';
import TranslationTextAreaPopup from '../hooks/TranslationTextAreaPopup'; // 👈 new
import { BorderBottom } from '@mui/icons-material';
import { FaGlobe } from 'react-icons/fa';

const PublishPopup = ({
  isOpen,
  onClose,
  onNext,
  revisionresponse,
  selectedLanguage,
  supportedLanguages = [], // 👈 new
}) => {
  const [revisionText, setRevisionText] = useState('');
  const [classificationChange, setClassificationChange] = useState(false);
  const [editorialChange, setEditorialChange] = useState(false);
  const [showTranslationPopup, setShowTranslationPopup] = useState(false); // 👈 new
  const [translations, setTranslations] = useState({}); // 👈 new

  const langMap = useLangMap();

  const t = useTranslation();

  useEffect(() => {
    if (!revisionresponse || !revisionresponse.revision_info) {
      setRevisionText('');
      return;
    }

    let revisionData = revisionresponse.revision_info;

    // 🔥 If revision_info is STRING → convert to JSON
    if (typeof revisionData === 'string') {
      try {
        revisionData = JSON.parse(revisionData);
      } catch (e) {
        logger.error('Invalid JSON in revision_info:', e);
        setRevisionText(revisionData);
        return;
      }
    }

    // Ab revisionData OBJECT hai 🟢
    const langKey = langMap[selectedLanguage] || 'EN';
    setRevisionText(revisionData?.[langKey]?.content || '');
    setTranslations(revisionData || {}); // 👈 new
  }, [revisionresponse, selectedLanguage]);

  if (!isOpen) return null;

  // 👉 NEXT button disabled logic
  const isNextDisabled = !classificationChange && !editorialChange;

  const isQuillEmpty = (value) => {
    if (!value) return true;
    const text = value.replace(/<(.|\n)*?>/g, '').trim();
    return text.length === 0;
  };

  return (
    <Modal modalStyle={{ width: '550px' }}>
      <h2 className="publish-popup-main" style={styles.heading}>
        {t('publish_process')}
      </h2>

      <h3 style={styles.subheading}>{t('classify_change')}</h3>
      <div style={{ fontSize: '12px', marginBottom: '15px' }}>
        {t('please_review_the_revision_information_and_classify_the_change')}
      </div>
      <h3 className="bb-none" style={styles.subheading}>
        {t('revision_info')}
      </h3>

      <div
        className="quill_boxes"
        style={{
          height: '240px',
          paddingBottom: '50px',
          position: 'relative',
          borderBottom: '1px solid #1A192B',
        }}
      >
        <button
          className="popup-button"
          style={{
            backgroundColor: '#002060',
            color: '#fff',
            padding: '4px 8px',
            fontSize: '12px',
            position: 'absolute',
            top: '3px',
            right: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '28px',
            width: '30px',
          }}
          onClick={() => setShowTranslationPopup(true)}
        >
          <FaGlobe />
        </button>
        <ReactQuill
          value={revisionText}
          onChange={(value) => {
            setRevisionText(value);
            const langKey = langMap[selectedLanguage] || 'EN';
            setTranslations((prev) => ({
              ...prev,
              [langKey]: {
                ...(typeof prev[langKey] === 'object' ? prev[langKey] : {}),
                content: value,
              },
            }));
          }}
          modules={{
            clipboard: {
              matchVisual: false,
            },
          }}
          style={{ height: '100%' }}
        />
      </div>

      <h3 className="bb-none" style={styles.subheading}>
        {t('classification_of_changes')}:
      </h3>

      <div style={styles.checkboxGroup}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '2px', cursor: 'pointer' }}>
          <input
            type="radio"
            style={{ marginLeft: '0', marginTop: '0' }}
            name="changeType"
            checked={classificationChange}
            onChange={() => {
              setClassificationChange(true);
              setEditorialChange(false);
            }}
          />
          {t('content_change')}
        </label>

        <label style={{ display: 'flex', alignItems: 'center', gap: '2px', cursor: 'pointer' }}>
          <input
            type="radio"
            name="changeType"
            style={{ marginLeft: '0', marginTop: '0' }}
            checked={editorialChange}
            onChange={() => {
              setEditorialChange(true);
              setClassificationChange(false);
            }}
          />
          {t('editorial_change')}
        </label>
      </div>

      <div style={styles.footer}>
        <button className="popup-button button_secondary" onClick={onClose}>
          {t('Cancel')}
        </button>

        <button
          className="popup-button button_primary"
          style={{
            // background: isNextDisabled ? "#c4c4c4" : "#007bff",
            cursor: isNextDisabled ? 'not-allowed' : 'pointer',
          }}
          disabled={isNextDisabled}
          onClick={() => {
            if (isQuillEmpty(revisionText)) {
              CustomAlert.warning(
                t('warning') || 'Warning',
                t('revision_info_is_required') || 'Revision info is required'
              );
              return;
            }

            onNext({
              revisionText,
              classificationChange,
              editorialChange,
              translations,
              selectedLanguage,
            });
          }}
        >
          {t('next')}
        </button>
      </div>

      {showTranslationPopup && (
        <TranslationTextAreaPopup
          isOpen={showTranslationPopup}
          onClose={() => setShowTranslationPopup(false)}
          defaultValues={translations}
          onSubmit={(values) => {
            setTranslations(values);
            const langKey = langMap[selectedLanguage] || 'EN';
            setRevisionText(values[langKey]?.content || '');
            setShowTranslationPopup(false);
          }}
          supportedLanguages={supportedLanguages}
        />
      )}
    </Modal>
  );
};

const styles = {
  heading: {
    margin: '0 0 10px 0',
    fontSize: '12px',
    fontWeight: '500',
    color: '#002060',
  },
  subheading: {
    margin: '10px 0 5px',
    fontSize: '12px',
    fontWeight: '500',
    color: '#002060',
    borderBottom: '1px solid #1A192B',
    paddingBottom: '5px',
  },
  label: { fontWeight: '600' },

  checkboxGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    marginTop: '10px',
    border: '1px solid #1A192B',
    padding: '5px 10px',
    fontSize: '12px',
  },

  footer: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'space-between',
  },
};

export default PublishPopup;
